<template>
  <carousel ref="carousel" v-bind="settings">
    <slide v-for="advertising in advertisings" :key="advertising.id">
      <div class="carousel-body" v-html="advertising.transContent"></div>
    </slide>
  </carousel>
</template>

<script>
  import CMS from '@/model/cms'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { Carousel, Slide },
    props: {
      widget: Object
    },
    data() {
      return {
        advertisings: [],
        carouselObserver: null,
        settings: {
          perPage: 5,
          dots: true,
          autoplay: true,
          paginationPosition: 'bottom',
          autoplayTimeout: 6000,
          loop: true
        }
      }
    },
    mounted() {
      CMS.getAdvertisingCarousel(this.widget.advertisingType)
        .then((response) => {
          this.advertisings = response.data
          this.$nextTick(this.prepareCarouselAccessibility)
        })
        .catch((error) => {
          //@todo ошибки
        })
    },
    updated() {
      this.$nextTick(this.updateCarouselAccessibility)
    },
    beforeDestroy() {
      if (this.carouselObserver) {
        this.carouselObserver.disconnect()
      }
    },
    methods: {
      prepareCarouselAccessibility() {
        this.updateCarouselAccessibility()

        const root = this.$refs.carousel && this.$refs.carousel.$el
        if (!root || this.carouselObserver) return

        this.carouselObserver = new MutationObserver(this.updateCarouselAccessibility)
        this.carouselObserver.observe(root, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-hidden', 'class']
        })
      },
      updateCarouselAccessibility() {
        const root = this.$refs.carousel && this.$refs.carousel.$el
        if (!root) return

        const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]'
        root.querySelectorAll('.carousel-body a[href]').forEach((link) => {
          const text = (link.getAttribute('aria-label') || link.innerText || link.textContent || '').trim()
          if (!text) {
            link.setAttribute('aria-label', this.$t('Баннер'))
          }
        })

        root.querySelectorAll('.VueCarousel-slide').forEach((slide) => {
          const hidden = slide.getAttribute('aria-hidden') === 'true'
          slide.querySelectorAll(focusableSelector).forEach((element) => {
            if (hidden) {
              if (!element.hasAttribute('data-a11y-prev-tabindex')) {
                element.setAttribute('data-a11y-prev-tabindex', element.getAttribute('tabindex') || '')
              }
              element.setAttribute('tabindex', '-1')
            } else if (element.hasAttribute('data-a11y-prev-tabindex')) {
              const previous = element.getAttribute('data-a11y-prev-tabindex')
              if (previous) {
                element.setAttribute('tabindex', previous)
              } else {
                element.removeAttribute('tabindex')
              }
              element.removeAttribute('data-a11y-prev-tabindex')
            }
          })
        })
      }
    }
  }
</script>
